import TextField from '@components/v2/form/TextField/TextField';
import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Button from '@components/v2/ui/Button/Button';
import { Controller } from 'react-hook-form';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import RecoveryEmailSent from './components/RecoveryEmailSent';
import useRecoverPasswordForm from './hooks/useRecoverPasswordForm';
import useRecoverPasswordPanelStyles from './recoverPasswordPanel.styles';

const RecoverPasswordPanel = () => {
  const { classes } = useRecoverPasswordPanelStyles();
  const { translate } = useTranslation();
  const { form, handleSubmit, loginPath, sentContent, resendButton } = useRecoverPasswordForm();

  if (sentContent) {
    return (
      <AuthPanel>
        <RecoveryEmailSent
          content={sentContent}
          resendButton={resendButton}
          loginPath={loginPath}
        />
      </AuthPanel>
    );
  }

  return (
    <AuthPanel description={LangEnum.LOGIN_RECOVER_DESCRIPTION}>
      <form onSubmit={handleSubmit} className={classes.form}>
        <Controller
          name="email"
          control={form.control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              type="email"
              autoComplete="email"
              label={translate(LangEnum.LOGIN_EMAIL)}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <div className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            loading={form.formState.isSubmitting}
          >
            {translate(LangEnum.GLOBAL_RECOVERY)}
          </Button>
          <Button variant="text" color="secondary" size="large" fullWidth to={loginPath}>
            {translate(LangEnum.GLOBAL_GO_BACK_TO_LOGIN)}
          </Button>
        </div>
      </form>
    </AuthPanel>
  );
};

export default RecoverPasswordPanel;
